// src/components/features/pixels/PixelCreationModal.jsx
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalDescription,
  ModalFooter,
  ModalClose,
} from '@/components/ui/modal';
import { CheckCircle2 } from 'lucide-react';

export function PixelCreationModal({ open, onOpenChange, pixelId }) {
  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent>
        <ModalHeader>
          <div className="sl-modal-icon-header flex items-center justify-center sm:justify-start gap-2 mb-2">
            <CheckCircle2 className="h-6 w-6 text-green-500" />
            <ModalTitle>Pixel Created Successfully!</ModalTitle>
          </div>
          <ModalDescription>
            Your new pixel has been created and is ready to be installed on your
            website.
          </ModalDescription>
        </ModalHeader>

        <div className="sl-modal-content-body py-4">
          <div className="sl-setup-steps space-y-4">
            <h3 className="font-medium text-gray-900">Next steps:</h3>
            <ol className="list-decimal pl-5 space-y-2 text-sm text-gray-600">
              <li>Copy the installation code from your pixel card</li>
              <li>
                Add the code to your website's{' '}
                <code className="text-sm font-mono bg-gray-100 rounded px-1">
                  &lt;head&gt;
                </code>{' '}
                section
              </li>
              <li>Set up integrations with your preferred CRM platforms</li>
              <li>Start tracking your marketing sources!</li>
            </ol>
          </div>

          <div className="sl-pixel-info mt-6 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm font-medium text-gray-900">
              Your new pixel ID:
            </p>
            <code className="text-sm font-mono text-primary-600">
              {pixelId}
            </code>
          </div>
        </div>

        <ModalFooter>
          <ModalClose asChild>
            <button className="sl-modal-close-btn inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-gray-200 bg-white hover:bg-gray-100 h-10 px-4 py-2">
              Got it, thanks!
            </button>
          </ModalClose>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
